import React, { useCallback, useEffect, useRef, useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import * as XLSX from "xlsx";
import { Input, Label, Modal, ModalBody, ModalHeader, Spinner, Table } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";

const PrintDoc = ({ innerRef, data }) => {
  const [pages, setPages] = useState([]);
  const maxColumns = 6;
  const rowRefs = useRef([]);
  const headerRef = useRef(null);

  useEffect(() => {
    if (!data?.body || !innerRef?.current) return;

    const containerStyle = getComputedStyle(innerRef.current);
    // const paddingTop = parseFloat(containerStyle.paddingTop) || 0;
    // const paddingBottom = parseFloat(containerStyle.paddingBottom) || 0;

    const headerHeight = headerRef.current.getBoundingClientRect().height;
    const containerHeight = innerRef.current.clientHeight - 240 - headerHeight;

    const pagesArr = [];
    let currentPage = [];
    let currentHeight = 0;

    rowRefs.current.forEach((rowEl, index) => {
      if (!rowEl) return;

      const rowHeight = rowEl.getBoundingClientRect().height;
      const projectedHeight = currentHeight + rowHeight;

      if (rowHeight > containerHeight) {
        if (currentPage.length > 0) pagesArr.push(currentPage);
        pagesArr.push([data.body[index]]);
        currentPage = [];
        currentHeight = 0;
        return;
      }

      if (projectedHeight > containerHeight) {
        pagesArr.push(currentPage);
        currentPage = [];
        currentHeight = 0;
      }

      currentPage.push(data.body[index]);
      currentHeight += rowHeight;
    });

    if (currentPage.length > 0) pagesArr.push(currentPage);

    setPages(pagesArr);
  }, [data]);
  if (!data) return null;

  return (
    <div
      style={{
        left: "0",
        width: "795px",
        zIndex: "-9999999",
        transform: "translate(-9999px, -9999px)",
        overflow: "scroll",
        position: "absolute",
      }}
    >
      <div
        ref={innerRef}
        style={{
          padding: "0px 60px",
          height: "1122.5px",
          width: "795px",
          position: "relative",
        }}
      >
        <div
          style={{
            padding: "0px 60px",
            left: "0",
            width: "100%",
            position: "absolute",
            visibility: "hidden",
            // background: "red"
          }}
        >
          <div style={{ padding: "60px 0" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", border: "0.2mm solid #000" }}>
              <thead ref={headerRef}>
                <tr>
                  {data.header.slice(0, maxColumns).map((h, i) => (
                    <th
                      key={i}
                      style={{
                        minWidth: "112.5px",
                        border: "0.2mm solid red",
                        padding: "8px",
                        background: "#91C8E4",
                        textAlign: "left",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.body.map((row, i) => (
                  <tr key={i} ref={(el) => (rowRefs.current[i] = el)}>
                    {row.slice(0, maxColumns).map((cell, j) => (
                      <td key={j} style={{ border: "0.2mm solid #000", padding: "8px" }}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {pages.map((page, pi) => (
          <div key={pi} style={{ padding: "60px 0", pageBreakAfter: "always" }}>
            {/* <div>Halaman {pi + 1}</div> */}
            <table style={{ width: "100%", borderCollapse: "collapse", border: "0.2mm solid #000" }}>
              <thead>
                <tr>
                  {data.header.slice(0, maxColumns).map((h, i) => (
                    <th
                      key={i}
                      style={{
                        minWidth: "112.5px",
                        border: "0.2mm solid #000",
                        padding: "8px",
                        background: "#91C8E4",
                        textAlign: "left",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {page.map((row, ri) => (
                  <tr key={ri}>
                    {row.slice(0, maxColumns).map((cell, ci) => (
                      <td key={ci} style={{ border: "0.2mm solid #000", padding: "8px" }}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

const ExportDoc = ({ data = [] }) => {
  // console.log(data, "okkkk11111");
  
  const printRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataTabel, setDataTabel] = useState([]);
  const [excelData, setExcelData] = useState({
    header: [],
    body: [],
  });

  const [checkAll, setCheckAll] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: () => {
      return printRef.current;
    },
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  function handleDownloadExcel() {
    const { header, body } = excelData;
    const numberHeader = ["No", ...header];
    const numberBody = body.map((row, index) => [index + 1, ...row]);
    const data = [numberHeader, ...numberBody];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const colWidths = numberHeader.map((_, colIndex) => {
      const maxLen = data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 0;
        return Math.max(max, len);
      }, 0);
      return { wch: maxLen + 2 };
    });

    ws["!cols"] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, "export-data.xlsx");
    // downloadExcel({
    //   fileName: "export-table-to-excel -> downloadExcel method",
    //   sheet: "export-table-to-excel",
    //   tablePayload: {
    //     header: excelData.header,
    //     body: excelData.body,
    //   },
    // });
  }

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      const allDataEmpty = data.every((item) => Array.isArray(item.data) && item.data.length === 0);
      if (allDataEmpty) {
        toast.error("Ceklis dahulu data yang ingin di print", {
          autoClose: 3000,
        });
        setModal(false);
      } else {
        setModal(true);
      }
    }
  }, [modal, data]);

  const handleCheckAll = (e) => {
    setCheckAll(!checkAll);
    setDataTabel((prevVal) => {
      return prevVal.map((item) => {
        return {
          ...item,
          isSelected: !checkAll,
        };
      });
    });
  };

  useEffect(() => {
    setDataTabel(
      data.map((item, index) => {
        // // if (index >= 6) {
        // //   return {
        // //     ...item,
        // //     isSelected: false,
        // //   };
        // // }

        // return item;

        return {
          ...item,
          isSelected: false,
        };
      })
    );
  }, [data]);

  useEffect(() => {
    if (dataTabel.length > 0) {
      const result = {
        header: [],
        body: [],
      };

      const selectedItems = dataTabel.filter((item) => item.isSelected);
      result.header = selectedItems.map((item) => item.label);
      const numRows = selectedItems[0]?.data?.length;
      for (let i = 0; i < numRows; i++) {
        const row = selectedItems.map((item) => item.data[i]);
        result.body.push(row);
      }

      setExcelData(result);
    }
  }, [dataTabel]);

  const isSixSelected = (data) => {
    const selectedCount = data.filter((item) => item.isSelected).length;
    return selectedCount === 6;
  };

  useEffect(() => {
    const allSelected = dataTabel.every((item) => item.isSelected === true);
    setCheckAll(allSelected);
  }, [dataTabel]);

  return (
    <>
      <button type="button" className="btn btn-success" onClick={toggle}>
        <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
      </button>
      <Modal id="showModalDetail" isOpen={modal} centered size="md">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Pengaturan Export
        </ModalHeader>
        <ModalBody>
          <div className="row p3">
            <p>PDF Hanya dapat menampilkan 6 kolom terpilih</p>
            <div
              style={{
                paddingLeft: "47px",
                marginBottom: "10px",
              }}
            >
              <div className=" form-check form-switch form-switch-custom form-switch-success">
                <Input
                  className={"form-check-input checked-all checked-method-all check-all"}
                  type="checkbox"
                  role="switch"
                  id={"check-all"}
                  checked={checkAll}
                  // disabled={!item.isSelected && isDisabled === true ? true : item.isSelected && dataTabel.filter((data) => data.isSelected).length === 1}
                  onChange={handleCheckAll}
                />
                <div>Semua</div>
              </div>
            </div>
            {(dataTabel || []).map((item, idx) => {
              return (
                <div key={idx} className={"col-lg-6 d-flex align-items-center justify-content-center mb-1 gap-1 form-check form-switch form-switch-custom form-switch-success"}>
                  <Input
                    className={"form-check-input checked-all checked-method-all check-" + item + idx}
                    type="checkbox"
                    role="switch"
                    id={"check-" + item + idx}
                    checked={item.isSelected}
                    // disabled={!item.isSelected && isDisabled === true ? true : item.isSelected && dataTabel.filter((data) => data.isSelected).length === 1}
                    onChange={(e) => {
                      //console.log(item.isSelected);

                      // let isValid = false;

                      // if (item.isSelected && isSixSelected(dataTabel)) {
                      //   isValid = true;
                      // } else if (!item.isSelected && !isSixSelected(dataTabel)) {
                      //   isValid = true;
                      // } else if (item.isSelected && !isSixSelected(dataTabel)) {
                      //   isValid = true;
                      // }

                      // if (isValid) {
                      //   const newDataTabel = [...dataTabel];
                      //   newDataTabel[idx].isSelected = true; //!newDataTabel[idx].isSelected;
                      //   setDataTabel(newDataTabel);
                      // }
                      const newDataTabel = [...dataTabel];
                      newDataTabel[idx].isSelected = !item.isSelected; //!newDataTabel[idx].isSelected;
                      setDataTabel(newDataTabel);
                    }}
                  />
                  <div className="fs-12 text-uppercase">
                    <input
                      value={item.label}
                      onChange={(e) => {
                        setDataTabel((prevData) => prevData.map((itm) => (itm.id === item.id ? { ...itm, label: e.target.value } : itm)));
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={toggle}>
              Close
            </button>
            <button type="submit" className="btn btn-info" onClick={handlePrint}>
              Pdf&nbsp;
              {loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
            </button>
            <button type="submit" className="btn btn-info" onClick={handleDownloadExcel}>
              Excel
            </button>
          </div>
        </div>
      </Modal>
      <PrintDoc innerRef={printRef} data={excelData} />
    </>
  );
};

export default ExportDoc;
